import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { SimTooltipComponent } from '@simOn/ui/sim-tooltip';
import { AiAssistantPanelService } from './ai-assistant-panel.service';

/**
 * Top navbar launcher of the AI assistant chat panel; rendered only where the assistant is available.
 * Styled like the logged user avatar (initials in a circle) so it reads as one more "person" in the bar.
 */
@Component({
  selector: 'layout-ai-assistant-button',
  imports: [SimTooltipComponent],
  template: `
    @if (panel.available()) {
      <sim-tooltip [tooltip]="label" [focusable]="false">
        <button
          type="button"
          id="ai-assistant-launcher"
          class="ai-assistant-launcher"
          [class.ai-assistant-launcher--active]="panel.open()"
          [attr.aria-label]="label"
          [attr.aria-pressed]="panel.open()"
          (click)="panel.toggle()"
        >
          <span class="ai-assistant-launcher__avatar">AI</span>
        </button>
      </sim-tooltip>
    }
  `,
  styleUrl: './ai-assistant-button.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AiAssistantButtonComponent {
  protected readonly panel = inject(AiAssistantPanelService);
  protected readonly label = $localize`:@@AI_AGENT_TITLE:AI Assistant`;
}
